"use strict";
(() => {
    const blocks = document.querySelectorAll('main > section, .text-modules-container > div');
    const container = document.querySelector('.page-navigation');
    const pageNavigationLinks = Array.from(container.querySelectorAll('.page-navigation .link')).map(el => {
        const url = new URL(el.href);
        return { el, anchorTag: url.hash.replace('#', '') };
    });
    const dropdown = document.getElementById('page-navigation-dropdown');
    const linkContainer = container.querySelector('.page-navigation .link-container');
    const idsInView = [];
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const entryId = entry.target.id;
            // TODO we need to tweak or rewrite this to handle small sections, as those are not picked up by this 30% minimum
            if ((entry.intersectionRatio * entry.target.scrollHeight) / window.innerHeight >= 0.3) {
                // If section fills more than 50% of viewport add it to the array
                if (!idsInView.includes(entryId)) {
                    idsInView.push(entryId);
                }
            }
            else {
                // Else remove it
                const index = idsInView.indexOf(entryId);
                if (index > -1) {
                    idsInView.splice(index, 1);
                }
            }
        });
        const [firstId] = idsInView;
        if (firstId) {
            dropdown.value = firstId;
        }
        pageNavigationLinks.forEach(link => {
            if (link.anchorTag === firstId) {
                link.el.classList.add('active');
            }
            else {
                link.el.classList.remove('active');
            }
        });
    }, 
    // Set lots of thresholds to increase accuracy
    {
        threshold: [
            0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1,
        ],
    });
    blocks.forEach(block => {
        const foundPaginationLink = pageNavigationLinks.find(link => link.anchorTag === block.id);
        if (block.id && foundPaginationLink) {
            observer.observe(block);
        }
    });
    dropdown.addEventListener('change', () => {
        // Find the selected element and scroll it into view
        const targetEl = document.getElementById(dropdown.value);
        if (targetEl) {
            targetEl.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
    });
    // Automatically collapse to dropdown mode if needed
    window.addEventListener('resize', collapseLinksIfNeeded);
    function collapseLinksIfNeeded() {
        if (linkContainer.scrollWidth > linkContainer.offsetWidth) {
            container.classList.add('is-collapsed');
        }
        else {
            container.classList.remove('is-collapsed');
        }
    }
    // Check on init
    collapseLinksIfNeeded();
})();
